import { Autoplay } from 'swiper/modules';
import { createSlider, reducedMotionQuery, syncSlides } from '@/utils/slider';

document.querySelectorAll('[data-hero-slider]').forEach((viewport) => {
    const root = viewport.closest('.hero-slider');
    if (!root || viewport.querySelectorAll('[data-hero-slide]').length < 2) {
        return;
    }

    const reduceMotion = reducedMotionQuery.matches;
    const pause = root.querySelector('[data-hero-pause]');
    if (reduceMotion && pause) {
        pause.hidden = true;
    }

    root.classList.add('is-ready');

    const swiper = createSlider(viewport, {
        modules: [Autoplay],
        prev: root.querySelector('[data-hero-prev]'),
        next: root.querySelector('[data-hero-next]'),
        dots: root.querySelector('[data-hero-dots]'),
        speed: 500,
        slidesPerView: 1,
        loop: true,
        autoplay: reduceMotion
            ? false
            : {
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
    });

    const reveal = () => syncSlides(viewport.querySelectorAll('[data-hero-slide]'));
    swiper.on('slideChangeTransitionEnd', reveal);
    reveal();

    if (!pause || reduceMotion) {
        return;
    }

    pause.addEventListener('click', () => {
        const paused = pause.getAttribute('aria-pressed') === 'true';
        if (paused) {
            swiper.autoplay.start();
            pause.setAttribute('aria-pressed', 'false');
            pause.textContent = 'Pause';
            return;
        }
        swiper.autoplay.stop();
        pause.setAttribute('aria-pressed', 'true');
        pause.textContent = 'Play';
    });
});
